import Appsignal from "@appsignal/javascript"
import { plugin as windowEvents } from "@appsignal/plugin-window-events"
import { router } from "@inertiajs/react"

let appsignal: Appsignal | null = null

export function startErrorReporting() {
  if (typeof window === "undefined") return

  const key = document.querySelector<HTMLMetaElement>(
    'meta[name="appsignal-frontend-key"]',
  )?.content
  if (!key) return

  appsignal = new Appsignal({
    key,
    namespace: "frontend",
    // Inertia appends the URL: "Network error (https://…/dashboard)".
    ignoreErrors: [/^Network error( \(.*\))?$/, /ResizeObserver loop/],
  })
  appsignal.use(windowEvents())

  let component = ""
  router.on("navigate", (event) => {
    component = event.detail.page.component
  })
  appsignal.addDecorator((span) => span.setAction(component))
}

export function reportCaughtError(message: string, error: unknown) {
  console.error(message, error)
  if (!appsignal) return

  const reported = error instanceof Error ? error : new Error(String(error))
  void appsignal.sendError(reported, (span) => span.setTags({ message }))
}
